let qsProduct = null;
let qsCurrentVariant = null;

const qsModal = document.querySelector('#quick-shop');
const qsImage = document.querySelector('#qs-image');
const qsTitle = document.querySelector('#qs-title');
const qsDescription = document.querySelector('#qs-description');
const qsPrice = document.querySelector('#qs-price');
const qsVariantName = document.querySelector('#qs-variant-name');
const qsColors = document.querySelector('#qs-colors');
const qsSizes = document.querySelector('#qs-sizes');
const qsLengths = document.querySelector('#qs-lengths');
const qsVariantId = document.querySelector('#qs-variant-id');
const qsImageWrap = document.querySelector('.qs-image');
const qsReview = document.querySelector('#qs-review');

async function openQuickShop(handle, selectedColor) {
  const res = await fetch(`/products/${handle}.js`);
  qsProduct = await res.json();

  qsTitle.textContent = qsProduct.title;
  qsDescription.textContent = stripHTML(qsProduct.description);
  buildColors(selectedColor);
  buildSizes();
  buildLengths();

  qsModal.classList.add('active');
  qsModal.setAttribute('aria-hidden', 'false');
  qsModal.removeAttribute('inert');
  updateVariant();
}

function copyReviewBadge(btn) {
  const card = btn.closest('.women-product-card'); // adjust selector if needed
  const badge = card.querySelector('.jdgm-preview-badge');

  if (!badge) return;

  const clone = badge.cloneNode(true);

  const qsReview = document.querySelector('#qs-review');
  qsReview.innerHTML = '';
  qsReview.appendChild(clone);
}

function stripHTML(html) {
  const temp = document.createElement('div');
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || '';
}

function closeQuickShop() {
  /*
   * ACCESSIBILITY FIRST
   */
  qsModal.setAttribute('aria-hidden', 'true');

  qsModal.setAttribute('inert', '');

  /*
   * REMOVE ACTIVE
   */
  qsModal.classList.remove('active');

  /*
   * RESET CONTENT
   */
  qsImage.src = '';

  qsTitle.textContent = '';

  qsPrice.textContent = '';

  qsDescription.textContent = '';

  qsVariantName.textContent = '';

  qsColors.innerHTML = '';

  qsSizes.innerHTML = '';

  qsVariantId.value = '';

  qsProduct = null;

  qsCurrentVariant = null;

  /*
   * RETURN FOCUS
   */
  setTimeout(() => {
    lastQuickShopTrigger?.focus();
  }, 100);
}

function buildColors(selectedColor) {
  qsColors.innerHTML = '';

  const colorOption = qsProduct.options.find((o) => o.name.toLowerCase().includes('color'));

  if (!colorOption) return;

  const allowedColors = window.allowedVariantColors.map((c) => c.trim().toLowerCase());

  colorOption.values.forEach((color) => {
    // SKIP disallowed colors
    if (!allowedColors.includes(color.trim().toLowerCase())) {
      return;
    }

    const btn = document.createElement('button');

    btn.className = 'qs-color color-swatch qs-color-swatch';

    btn.dataset.color = color;

    btn.title = color;

    /* find swatch in product card */
    const swatch = document.querySelector(`.color-swatch[data-color="${color}"]`);

    const swatchImg = swatch?.querySelector('img');

    if (swatchImg) {
      btn.style.backgroundImage = `url(${swatchImg.src})`;
      btn.style.backgroundSize = 'cover';
      btn.style.backgroundPosition = 'center';
    } else {
      btn.style.background = color;
    }

    if (color === selectedColor) {
      btn.classList.add('active');
    }

    qsColors.appendChild(btn);
  });
}

function buildSizes() {
  qsSizes.innerHTML = '';

  const sizeOption = qsProduct.options.find((o) => o.name.toLowerCase().includes('size'));
  if (!sizeOption) return;

  sizeOption.values.forEach((size, index) => {
    const btn = document.createElement('button');

    btn.className = 'qs-size';
    btn.dataset.size = size;
    btn.textContent = size;

    if (index === 0) btn.classList.add('active');

    qsSizes.appendChild(btn);
  });

  buildLengths(); // IMPORTANT
}

function buildLengths() {
  qsLengths.innerHTML = '';

  const activeColor = document.querySelector('.qs-color.active')?.dataset.color;
  const activeSize = document.querySelector('.qs-size.active')?.dataset.size;

  const lengthOption = qsProduct.options.find(
    (o) => o.name.toLowerCase().includes('length') || o.name.toLowerCase().includes('inseam'),
  );

  const qsLengthLabel = document.querySelector('.length-label');

  if (!lengthOption) {
    if (qsLengthLabel) qsLengthLabel.style.display = 'none';
    return;
  } else {
    if (qsLengthLabel) qsLengthLabel.style.display = '';
  }

  if (!lengthOption) return;

  let firstAvailableBtn = null;

  lengthOption.values.forEach((length) => {
    const btn = document.createElement('button');

    btn.className = 'qs-length';
    btn.dataset.length = length;
    btn.textContent = length;
    const isAvailable = qsProduct.variants.some(
      (v) =>
        v.available && v.options.includes(activeColor) && v.options.includes(activeSize) && v.options.includes(length),
    );

    if (!isAvailable) {
      btn.classList.add('is-disabled');
      btn.disabled = true;
    } else if (!firstAvailableBtn) {
      firstAvailableBtn = btn;
    }

    qsLengths.appendChild(btn);
  });

  if (firstAvailableBtn) {
    firstAvailableBtn.classList.add('active');
  }
}

// function updateVariant() {
//   const activeColor = document.querySelector('.qs-color.active')?.dataset.color;
//   const activeSize = document.querySelector('.qs-size.active')?.dataset.size;
//   const activeLength = document.querySelector('.qs-length.active')?.dataset.length;

//   console.log(activeColor);

//   qsVariantName.textContent = activeColor;

//   if (!activeColor || !activeSize) return;

//   console.log(qsProduct);

//   qsProduct.variants.forEach((v) => {
//     console.log(v.options);
//   });

//   console.log(activeColor);
//   console.log(activeSize);
//   console.log(activeLength);

//   const variant = qsProduct.variants.find((v) => {
//     const matchColor = v.options.includes(activeColor);
//     const matchSize = v.options.includes(activeSize);
//     const matchLength = activeLength ? v.options.includes(activeLength) : true;

//     return matchColor && matchSize && matchLength;
//   });

//   console.log(variant);

//   const addBtn = document.querySelector('.qs-add');

//   if (!variant || !variant.available) {
//     qsVariantId.value = '';
//     addBtn.disabled = true;
//     return;
//   }

//   qsCurrentVariant = variant;
//   qsVariantId.value = variant.id;

//   addBtn.disabled = false;

//   qsPrice.textContent = '$' + Math.round(variant.price / 100);
//   if (variant.featured_image && qsProduct.images) {
//     const startIndex = variant.featured_image.position - 1;
//     const secondImage = qsProduct.images[startIndex + 1] || qsProduct.images[startIndex];

//     qsImageWrap.classList.remove('loaded');

//     qsImage.onload = () => {
//       qsImageWrap.classList.add('loaded');
//     };

//     console.log(secondImage);

//     qsImage.src = secondImage + '&width=900';
//   }
// }

function updateVariant() {
  const activeColor = document.querySelector('.qs-color.active')?.dataset.color;
  const activeSize = document.querySelector('.qs-size.active')?.dataset.size;
  const activeLength = document.querySelector('.qs-length.active')?.dataset.length;

  const addBtn = document.querySelector('.qs-add');

  qsVariantName.textContent = activeColor || '';

  // Reset
  qsVariantId.value = '';
  addBtn.disabled = true;

  if (!activeColor) return;

  const normalize = (str) => str?.trim().toLowerCase();

  /* FIND COLOR MATCHING VARIANTS */
  const colorVariants = qsProduct.variants.filter((v) => {
    return v.options.some((opt) => normalize(opt) === normalize(activeColor));
  });

  /* UPDATE IMAGE ALWAYS (even unavailable variants) */
  const imageVariant = colorVariants[0];

  if (imageVariant?.featured_image && qsProduct.images) {
    const startIndex = imageVariant.featured_image.position - 1;

    const secondImage = qsProduct.images[startIndex + 1] || qsProduct.images[startIndex];

    qsImageWrap.classList.remove('loaded');

    qsImage.onload = () => {
      qsImageWrap.classList.add('loaded');
    };

    qsImage.src = secondImage + '&width=900';
  }

  /*DISABLE UNAVAILABLE SIZES*/
  document.querySelectorAll('.qs-size').forEach((btn) => {
    const size = btn.dataset.size;

    const sizeAvailable = colorVariants.some((variant) => {
      const matchSize = variant.options.some((opt) => normalize(opt) === normalize(size));

      return matchSize && variant.available;
    });

    btn.disabled = !sizeAvailable;
    btn.classList.toggle('disabled', !sizeAvailable);

    // remove active if disabled
    if (!sizeAvailable && btn.classList.contains('active')) {
      btn.classList.remove('active');
    }
  });

  /*NO SIZE SELECTED YET*/
  if (!activeSize) return;

  /*FIND EXACT VARIANT*/
  const variant = qsProduct.variants.find((v) => {
    const options = v.options.map(normalize);

    const matchColor = options.includes(normalize(activeColor));
    const matchSize = options.includes(normalize(activeSize));

    const matchLength = activeLength ? options.includes(normalize(activeLength)) : true;

    return matchColor && matchSize && matchLength;
  });

  /* UNAVAILABLE VARIANT*/
  if (!variant || !variant.available) {
    addBtn.disabled = true;
    return;
  }

  /*AVAILABLE VARIANT*/
  qsCurrentVariant = variant;

  qsVariantId.value = variant.id;

  addBtn.disabled = false;

  qsPrice.textContent = '$' + Math.round(variant.price / 100);
}

// function updateVariant() {
//   const activeColor = document.querySelector('.qs-color.active')?.dataset.color;
//   const activeSize = document.querySelector('.qs-size.active')?.dataset.size;
//   const activeLength = document.querySelector('.qs-length.active')?.dataset.length;

//   qsVariantName.textContent = activeColor;

//   if (!activeColor || !activeSize) return;

//   const variant = qsProduct.variants.find((v) => {
//     const matchColor = v.options.includes(activeColor);
//     const matchSize = v.options.includes(activeSize);
//     const matchLength = activeLength ? v.options.includes(activeLength) : true;

//     return matchColor && matchSize && matchLength;
//   });

//   const addBtn = document.querySelector('.qs-add');

//   if (!variant || !variant.available) {
//     qsVariantId.value = '';
//     addBtn.disabled = true;
//     return;
//   }

//   qsCurrentVariant = variant;
//   qsVariantId.value = variant.id;

//   addBtn.disabled = false;

//   qsPrice.textContent = '$' + Math.round(variant.price / 100);

//   if (variant.featured_image && qsProduct.images) {
//     const startIndex = variant.featured_image.position - 1;
//     const secondImage = qsProduct.images[startIndex + 1] || qsProduct.images[startIndex];

//     qsImageWrap.classList.remove('loaded');

//     qsImage.onload = () => {
//       qsImageWrap.classList.add('loaded');
//     };

//     qsImage.src = secondImage + '&width=900';
//   }
// }

document.addEventListener('click', async function (e) {
  const quickBtn = e.target.closest('.quick-shop-btn');

  /*
  -----------------------------------
  OPEN QUICK SHOP
  -----------------------------------
  */
  if (quickBtn) {
    /*
     * STORE TRIGGER BUTTON
     */
    lastQuickShopTrigger = quickBtn;

    const handle = quickBtn.dataset.productHandle;
    const color = quickBtn.dataset.selectedColor;

    /* start loader */
    quickBtn.classList.add('is-loading');
    quickBtn.disabled = true;

    try {
      await openQuickShop(handle, color);

      copyReviewBadge(quickBtn);

      const closeBtn = document.querySelector('.quick-shop-panel .quick-shop-close');

      closeBtn?.focus();
    } catch (err) {
      console.error(err);
    } finally {
      /* stop loader */
      quickBtn.classList.remove('is-loading');
      quickBtn.disabled = false;
    }

    return; // stop further click processing
  }

  /*
  -----------------------------------
  CLOSE QUICK SHOP
  -----------------------------------
  */
  if (
    e.target.closest('.quick-shop-overlay') ||
    e.target.closest('.quick-shop-close') ||
    e.target.closest('.qs-keep')
  ) {
    closeQuickShop();

    /*
     * RETURN FOCUS TO OPEN BUTTON
     */
    setTimeout(() => {
      lastQuickShopTrigger?.focus();
    }, 100);

    return;
  }

  /*
  -----------------------------------
  COLOR
  -----------------------------------
  */
  const colorBtn = e.target.closest('.qs-color');

  if (colorBtn) {
    document.querySelectorAll('.qs-color').forEach((b) => b.classList.remove('active'));

    colorBtn.classList.add('active');

    buildLengths();

    updateVariant();
  }

  /*
  -----------------------------------
  SIZE
  -----------------------------------
  */
  const sizeBtn = e.target.closest('.qs-size');

  if (sizeBtn) {
    document.querySelectorAll('.qs-size').forEach((b) => b.classList.remove('active'));

    sizeBtn.classList.add('active');

    buildLengths();

    updateVariant();
  }

  /*
  -----------------------------------
  LENGTH
  -----------------------------------
  */
  const lengthBtn = e.target.closest('.qs-length:not(.is-disabled)');

  if (lengthBtn) {
    document.querySelectorAll('.qs-length').forEach((b) => b.classList.remove('active'));

    lengthBtn.classList.add('active');

    updateVariant();
  }
});

/*
-----------------------------------
ESC CLOSE QUICK SHOP
-----------------------------------
*/

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape' && e.key !== 'Esc') return;

  const quickShop = document.querySelector('.quick-shop');

  /*
   * QUICK SHOP OPEN?
   */
  if (quickShop && quickShop.classList.contains('active')) {
    e.preventDefault();

    closeQuickShop();
  }
});

/*
-----------------------------------
ESC CLOSE QUICK SHOP
RETURN FOCUS TO TRIGGER BUTTON
-----------------------------------
*/

// document.addEventListener('click', async function (e) {
//   const quickBtn = e.target.closest('.quick-shop-btn');

//   if (quickBtn) {
//     /*
//      * STORE TRIGGER BUTTON
//      */
//     lastQuickShopTrigger = quickBtn;
//   }
// });

// document.addEventListener('keydown', function (e) {
//   if (e.key !== 'Escape' && e.key !== 'Esc') return;

//   const quickShop = document.querySelector('.quick-shop');

//   /*
//    * QUICK SHOP OPEN?
//    */
//   if (quickShop && quickShop.classList.contains('active')) {
//     e.preventDefault();

//     closeQuickShop();

//     /*
//      * RETURN FOCUS
//      */
//     setTimeout(() => {
//       lastQuickShopTrigger?.focus();
//     }, 100);
//   }
// });

/* AJAX ADD TO CART (cart drawer support) */
document.querySelector('.qs-add').addEventListener('click', async function (e) {
  e.preventDefault();

  const variantId = qsVariantId.value;

  if (!variantId) return;

  try {
    this.disabled = true;
    this.textContent = 'Adding to cart';

    await window.CartUtils.addItemToCart(variantId, 1);

    closeQuickShop();

    await window.CartUtils.refreshCartDrawer();

    /*
     * MOVE FOCUS TO CART DRAWER
     */
    setTimeout(() => {
      const cartDrawer = document.querySelector('.drawer__inner');

      cartDrawer?.focus();
    }, 300);
  } catch (err) {
    console.error(err);
  } finally {
    this.disabled = false;
    this.textContent = 'Add to cart';
  }
});
